import { Stack } from '@mantine/core';
import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import { TaskFormColleague } from 'modules/Tasks';
import { Controller, useFormContext } from 'react-hook-form';
import FormSection from 'shared/forms/FormSection';
import { CustomSelect, Input } from 'shared/io';
import type { RecoveryPlanStep } from 'types/recovery-plan';

import styleIdentifiers from './RecoveryStepForm.module.scss';

const styles = classNames.bind(styleIdentifiers);

export const RecoveryStepFormAICall = () => {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
  } = useFormContext<RecoveryPlanStep>();

  register('step_type', { required: true, value: 'initiate_ai_call' });

  return (
    <Stack align="stretch" gap={1} h="100%">
      <Input
        label={t(i18nKeys.DELAY_WITH_PREVIOUS_ACTION)}
        register={register('delay', { required: true, min: 1 })}
        errorMessage={errors.delay}
        type="number"
        withBorder
      />
      <FormSection title={t(i18nKeys.FORM.AI_CALL.FOLLOW_UP)} className={styles('form-section')}>
        <TaskFormColleague name="task_attributes.user_id" />
        <Controller
          name="task_attributes.mandatory"
          rules={{ required: true }}
          render={() => (
            <CustomSelect
              label={t(i18nKeys.TASK.ATTRIBUTES.MANDATORY)}
              keyText="description"
              keyValue="value"
              name="task_attributes.mandatory"
              withBorder
              items={[
                { description: t(i18nKeys.YES), value: 'true' },
                { description: t(i18nKeys.NO), value: 'false' },
              ]}
            />
          )}
        />
      </FormSection>
    </Stack>
  );
};
